import { State } from './state';

export function getOrganizationId(state: State) {
  return state.organizationExternalId;
}

export function getUserExternalId(state: State) {
  return state.user.id;
}

export const selectUserAuthToken = (state: State) => state.user?.authToken;

export const selectUserFirstName = (state: State) =>
  state.navBar.userProfile.data?.firstName;

export const selectUserLastName = (state: State) =>
  state.navBar.userProfile.data?.lastName;

export const selectUserEmail = (state: State) => state.user?.email;

export const selectOrganizationId = (state: State) =>
  state.organizationExternalId;

export const selectFlags = (state: State) => state.featureFlags;

export const selectUserProfile = (state: State) =>
  state.navBar.userProfile.data;

export const selectUserProfileStatus = (state: State) =>
  state.navBar.userProfile.status;

export const selectUserProfileError = (state: State) =>
  state.navBar.userProfile.error;

export const selectUserProfileName = (state: State) => {
  if (state.navBar.userProfile.data?.firstName) {
    return `${state.navBar.userProfile.data?.firstName} ${state.navBar.userProfile.data?.lastName}`;
  }
  return '';
};

export const selectUserHasAcceptedTerms = (state: State) =>
  state.navBar.userProfile.data?.hasAcceptedTerms;

export const selectOrganizations = (state: State) =>
  state.navBar.organizations.data;

export const selectOrganizationsLength = (state: State) =>
  state.navBar.organizations.data?.length ?? 0;

export const selectOrganizationsStatus = (state: State) =>
  state.navBar.organizations.status;

export const selectOrganizationsError = (state: State) =>
  state.navBar.organizations.error;

export const selectOrganizationsFetched = (state: State) =>
  state.navBar.organizations.fetched;

export const selectOrganizationsPageInfo = (state: State) =>
  state.navBar.organizations.pageInfo;

export const selectVendorBooths = (state: State) =>
  state.navBar.vendorBooths.data;

export const selectVendorBoothsStatus = (state: State) =>
  state.navBar.vendorBooths.status;

export const selectVendorBoothsError = (state: State) =>
  state.navBar.vendorBooths.error;

export const selectVendorBoothsFetched = (state: State) =>
  state.navBar.vendorBooths.fetched;

export const selectVendorBoothsPageInfo = (state: State) =>
  state.navBar.vendorBooths.pageInfo;

export const selectIsOrgSelected = (state: State) => state.navBar.isOrgSelected;

export const selectIsLanguagePickerOpen = (state: State) =>
  state.navBar.isLanguagePickerOpen;

export const selectIsHelpMenuOpen = (state: State) =>
  state.navBar.isHelpMenuOpen;

export const selectIsOrgSwitcherOpen = (state: State) =>
  state.navBar.isOrgSwitcherOpen;

export const selectNavBarSelectedOrgInfo = (state: State) =>
  state.navBar.selectedOrgInfo;

export const selectFileDownloadUrl = (filename: string) => (state: State) =>
  state.fileDownloadUrls[filename];
